import React from "react";
import { HeaderDesktop } from "../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../components/header/mobile/HeaderMobile";
import Media from "react-media";
import { TerminalsState } from "../../states/TerminalsState";
import './Terminals.css'
import StateBadge from "../../components/badge/StateBadge";
import Collapsible from "../../components/collapsible/Collapsible";
import { ITerminalsDto } from "../../models/TerminalsDto";
import { Subscription } from 'rxjs';
import { SearchBarDesktop } from "../../components/searchbar/desktop/SearchBarDesktop";
import { ITerminalDto } from "../../models/TerminalDto";
import { SearchBarMobile } from "../../components/searchbar/mobile/SearchBarMobile";
import { SearchType } from "../../components/searchbar/SearchType";
import Skeleton from 'react-loading-skeleton';
import { MposWebPortalApi } from "../../services/api/MposWebPortalApi";
import { Pagination } from "../../utils/Pagination";
import { Button } from "@material-ui/core";
import { TidStatusDto } from "../../models/TidStatusDto";
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";
import { ServiceUnavailablePage } from "../service-unavailable-page/ServiceUnavailablePage";
import StateContextProvider from "../../context/StateContext";

export class Terminals extends React.Component<any, TerminalsState> {
    private getTerminalsSubscription: Subscription | null = null;
    private pagination: Pagination<ITerminalDto>;

    constructor(props: any) {
        super(props);
        this.state = {
            termIdCounter: 0,
            terminalsDto: null,
            terminalList: null,
            isLoading: false,
            terminalToShow: null,
            searchTextEmpty: true,
            searchFilteredResultNumber: null,
            getTerminalsError: false,
            sameTerminalsType: false,
        };

        this.pagination = new Pagination(5);
    }

    componentDidMount() {
        console.log("[Terminals] Fetching data...");

        this.setState({
            isLoading: true,
            sameTerminalsType: StateContextProvider.getInstance().getProp("sameTerminalsType"),
        });
        this.getTerminalsSubscription = MposWebPortalApi.getInstance().getTerminals().subscribe((terminalsDto: ITerminalsDto) => {
            this.setState({ terminalsDto: terminalsDto });
            this.setState({ terminalList: (terminalsDto !== null && terminalsDto.terminals !== null) ? terminalsDto.terminals! : [] }, () => {
                let termIds: any[] = [];
                this.state.terminalList!.forEach((value) => {

                    let status = (value.users === null || value.users?.length === 0) ? 'not active' : (value.tidStatus === TidStatusDto.ACTIVE) ? 'active' : 'not active';
                    termIds.push({
                        id: value.terminalId,
                        status: status,
                        pos_type: value.terminalType.toLowerCase(),
                    });
                });
                GoogleTagManagerService.getInstance().pushPageEvent(this.props.history.location.pathname, 'I tuoi terminali', { termId: termIds });
            });
            this.pagination.setInputData(this.sortArrayForTerminalId(terminalsDto.terminals!));
            this.getTerminalsToShow();

            if (this.state.sameTerminalsType) {
                this.setState({
                    isLoading: false,
                    getTerminalsError: false,
                    termIdCounter: terminalsDto.terminals !== null ? terminalsDto.terminals.length : 0
                });
            } else {
                this.setState({
                    isLoading: false,
                    termIdCounter: (terminalsDto !== null && terminalsDto.terminals !== null) ? terminalsDto.terminals!.length : 0
                });
            }
        }, (error) => {
            console.log("[Terminals] Error when try to fetch data! " + JSON.stringify(error));
            this.setState({
                terminalsDto: null,
                termIdCounter: 0,
                terminalList: null,
                isLoading: false,
                getTerminalsError: true,
            });
        });
    }

    componentWillUnmount() {
        if (this.getTerminalsSubscription != null) {
            this.getTerminalsSubscription.unsubscribe();
        }
    }

    private getTerminalsToShow() {
        this.setState({
            terminalToShow: this.pagination.getNext()
        });
    }

    private renderDesktopHeader(): JSX.Element {
        return (
            <HeaderDesktop showBack={false} showLogout={true} showTitle={false} selectedElement={2} title={"I tuoi terminali"} />);
    }

    private renderMobileHeader(): JSX.Element {
        return (
            <HeaderMobile showBack={true} showLogout={true} showTitle={true} title={"I tuoi terminali"} />);
    }

    private desktopSearchBarValueProvided(value: string) {
        this.pagination.resetPaginator();
        let filteredInput = this.filterElements(value);
        console.log("[Terminals] Filtered size: " + filteredInput.length);
        this.setState({ searchFilteredResultNumber: filteredInput.length });
        this.setState({ searchTextEmpty: value === "" });
        this.pagination.setInputData(filteredInput);
        this.getTerminalsToShow();
    }

    private filterElements(filter: string): Array<ITerminalDto> {
        let elements = Array.from(this.state.terminalsDto?.terminals!);
        if (filter.length >= 3) {
            // Send analytics
            GoogleTagManagerService.getInstance().pushInteractionEvent('RicercaOverlay', 'i tuoi terminali', 'search', 'ricerca id terminale');
            return elements.filter((obj) => {
                return obj.terminalId.includes(filter);
            });
        }

        return elements;
    }

    private sortArrayForTerminalId(array: ITerminalDto[] | undefined): ITerminalDto[] {
        if (array !== undefined) {
            return array.sort((a, b) => {
                return (b.terminalId > a.terminalId ? -1 : 1)
            });
        } else {
            return [];
        }
    }

    private sortListForUsername(users: string[] | undefined): string[] {
        if (typeof users !== 'undefined') {
            return users.sort(function (a, b) {
                if (a.toLowerCase() < b.toLowerCase()) { return -1; }
                if (a.toLowerCase() > b.toLowerCase()) { return 1; }
                return 0;
            });
        }

        return [];
    }

    private onDesktopSearchBarFocus() {
        if (this.state.searchFilteredResultNumber === null) {
            this.setState({
                searchFilteredResultNumber: this.state.terminalList?.length!
            });
        }
    }

    private onDesktopSearchBarBlur() {
        if (this.state.searchTextEmpty === true) {
            this.setState({
                searchFilteredResultNumber: null
            });
        }
    }

    private renderTidTile(tid: any) {
        return (
            <div key={tid.terminalId} className={"terminal-table-row"}>
                <div className={"terminal-table-row-content"}>
                    <p className={"terminal-tid-label"}>
                        <b>{tid.terminalId}</b>
                    </p>
                    <p className={"terminal-tid-label"}>
                        {tid.terminalType === 'MPOS' ? 'Mobile ' : 'Soft'}POS
                        {tid.softposType === 'B' && ' di supporto'}
                        {tid.softposType === 'A' && ' Aggiuntivo'}
                    </p>
                    <div className={"terminal-badge-container"}>
                        <StateBadge
                            badgeStateText="non assegnato"
                            userState={tid.tidStatus}
                        />
                    </div>
                    <Collapsible
                        header={(tid.users === null || tid.users?.length === 0) ? "Non assegnato" : tid.users?.length === 1 ?
                            "Assegnato a 1 utenza" : "Assegnato a " + tid.users?.length + " utenze"}
                        elements={this.sortListForUsername(tid.users)}
                    />
                </div>
            </div>
        )
    }

    render() {
        return this.state.getTerminalsError ? <ServiceUnavailablePage /> : <div id={"main-container-terminal"}>
            <Media query="(max-width: 1064px)" render={() => this.renderMobileHeader()} />
            <Media query="(min-width: 1065px)" render={() => this.renderDesktopHeader()} />
            {
                [this.state.isLoading && <div className={"terminal-container-content"}>
                    <p className={"terminal-counter-element"}>Hai <b>{this.state.termIdCounter}</b> ID Terminale disponibili</p>
                    <div className={"terminal-search-bar-container"}>
                        <Skeleton className={"terminal-searchbar-skeleton"} />
                    </div>
                    <div className={"terminal-table-container"}>
                        <Skeleton className={"terminal-table-skeleton"} />
                    </div>
                </div>,
                !this.state.isLoading && <div className={"terminal-container-content"}>
                    <Media query="(max-width: 1064px)" render={() => {
                        return <p className={"choose-terminal-counter-element"}>Hai <b>{this.state.termIdCounter}</b> ID Terminale disponibili</p>
                    }} />
                    <Media query="(min-width: 1065px)" render={() => {
                        return this.state.searchFilteredResultNumber === null ? <p className={"choose-terminal-counter-element"}>Hai <b>{this.state.termIdCounter}</b> ID Terminale disponibili</p> :
                            this.state.searchFilteredResultNumber === 1 ? <p className={"choose-terminal-counter-element"}><b>1</b> risultato trovato</p> :
                                <p className={"choose-terminal-counter-element"}><b>{this.state.searchFilteredResultNumber}</b> risultati trovati</p>
                    }} />
                    {this.state.termIdCounter > 10 &&
                        <div className={"terminal-search-bar-container"}>
                            <Media query="(min-width: 1065px)" render={() => {
                                return (
                                    <SearchBarDesktop
                                        placeholder={"Cerca per ID Terminale"}
                                        onFocus={() => { this.onDesktopSearchBarFocus() }}
                                        onBlur={() => { this.onDesktopSearchBarBlur() }}
                                        onValueChanged={(value: string) => { this.desktopSearchBarValueProvided(value) }} />
                                )
                            }} />
                            <Media query="(max-width: 1064px)" render={() => {
                                return (
                                    <SearchBarMobile
                                        values={this.state.terminalsDto?.terminals}
                                        type={SearchType.TERMINAL_INFO_WITH_USERS}
                                        placeholder={"Cerca per ID Terminale"} />
                                )
                            }}
                            />
                        </div>
                    }
                    {this.state.sameTerminalsType ? (
                        <div className={this.state.termIdCounter === 0 ? "terminal-table-container terminal-table-no-terminal-id" : "terminal-table-container"}>
                            {this.state.terminalToShow !== null && this.state.terminalToShow.map((element) => {
                                return this.renderTidTile(element)
                            })}
                            {this.pagination.hasMoreElements() &&
                                <Button id={"terminals-show-more-button"}
                                    onClick={() => this.getTerminalsToShow()}
                                    disableRipple
                                >
                                    {"Mostra di più".toUpperCase()}
                                </Button>
                            }
                        </div>
                    ) : (
                        <div className={this.state.termIdCounter === 0 ? "terminal-table-container terminal-table-no-terminal-id" : "terminal-table-container"}>
                            {this.state.terminalToShow !== null && this.state.terminalToShow.map((element) => {
                                return this.renderTidTile(element)
                            })}
                            {this.pagination.hasMoreElements() &&
                                <Button id={"terminals-show-more-button"}
                                    onClick={() => this.getTerminalsToShow()}
                                    disableRipple
                                >
                                    {"Mostra di più".toUpperCase()}
                                </Button>
                            }
                        </div>
                    )}
                </div>]
            }
        </div>
    }
}